"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertNever = void 0;
/**
 * should never be called in production
 */
function assertNever(x, label) {
    throw new Error(`Missing configuration label from type ${label} ${x}`);
}
exports.assertNever = assertNever;
//# sourceMappingURL=assert-never.js.map